var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeviceMileage01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M116,286.6c0,0,100-122.3,100-171.2c0-55.1-44.9-100-100-100S16,60.3,16,115.4C16,164.4,116,286.6,116,286.6z M116,55.4 c33.1,0,60,26.9,60,60c0,21.5-31.4,70.6-60,107.9C87.4,186,56,136.9,56,115.4C56,82.3,82.9,55.4,116,55.4L116,55.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396,225.4c-55.1,0-100,44.9-100,100c0,49,100,171.2,100,171.2s100-122.2,100-171.2C496,270.3,451.1,225.4,396,225.4z  M396,433.3c-28.6-37.3-60-86.4-60-107.9c0-33.1,26.9-60,60-60s60,26.9,60,60C456,346.9,424.6,396,396,433.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,425.4c0-16.5,13.5-30,30-30h100c38.6,0,70-31.4,70-70s-31.4-70-70-70h-10v40h10c16.5,0,30,13.5,30,30 c0,16.5-13.5,30-30,30H86c-38.6,0-70,31.4-70,70s31.4,70,70,70h250v-40H86C69.5,455.4,56,441.9,56,425.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,95.4h40v40H96V95.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,305.4h40v40h-40V305.4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceMileage01);
export default __webpack_public_path__ + "static/media/deviceMileage-01.72c6b71fcb1f9cf103a91b0324341268.svg";
export { ForwardRef as ReactComponent };